export const searchResultMock = {
  availabilityLabel: 'Availability',
  amenitiesLabel: 'Amenities',
  loadingLabel: 'Loading',
  guestRatingLabel: 'Guest Rating',
  totalPointsPerStayLabel: 'Total Points / Stay',
  anyDistanceLabel: 'Any Distance',
  recommendedLabel: 'Recommended',
  sortByOptionsList: [
    {
      sortByOptionTitle: 'Recommended',
      sortByOptionCode: 'RECOMMENDED',
    },
    {
      sortByOptionTitle: 'Default',
      sortByOptionCode: 'PROPERTY_NAME',
    },
    {
      sortByOptionTitle: 'Distance',
      sortByOptionCode: 'DISTANCE',
    },
    {
      sortByOptionTitle: 'Price (Low-to-High)',
      sortByOptionCode: 'PRICE',
    },
    {
      sortByOptionTitle: 'Rewards Points',
      sortByOptionCode: 'POINTS',
    },
    {
      sortByOptionTitle: 'City',
      sortByOptionCode: 'CITY',
    },
    {
      sortByOptionTitle: 'Brand',
      sortByOptionCode: 'BRAND',
    },
    {
      sortByOptionTitle: 'Guest Rating',
      sortByOptionCode: 'GUEST_RATINGS',
    },
    {
      sortByOptionTitle: 'Number of Reviews',
      sortByOptionCode: 'NUM_REVIEWS',
    },
  ],
  ':type': 'mi-aem-shop-spa/components/content/searchresults/v1/searchresults',
  pointsSaverLabel: 'PointSavers',
  sortByLabel: 'Sort by',
  resultsLabel: 'Results',
  anyPointsLabel: 'Any Points',
  defaultLabel: 'Default',
  id: 'searchresults-235b0a1329',
  tourismMarketingFeeLabel: 'Tourism Marketing Fee',
  callToBookLabel: 'Call to book',
  memberLoungeTooltipLabel:
    'Platinum Elite members and above enjoy lounge access and food and beverage offerings. Weekday and weekend availability and hours vary by property.',
  disableTextDescriptor: true,
  removeChildrenMessage: 'Please remove child guest(s) from your search.',
  resortLabel: 'Resort',
  wideFallBackImageURL: 'https://cache.marriott.com/is/image/marriotts7prod/ar-mspac-error-image-28944:Wide-Hor',
  fromDestinationLabel: 'from destination',
  viewRateLabel: 'View Rates',
  selectCurrencySubLabel: 'SHOW PRICE IN',
  reviewsLabel: 'reviews',
  pointBalanceLabel: 'Current Points Balance',
  reviewsShortLabel: 'reviews',
  selectAllLabel: 'Select All',
  brandIconLabel: 'brand icon',
  previousLabel: 'Previous',
  viewAvailabilityLabel: 'View Availability',
  fallBackAltText: 'Fallback',
  distanceMeasurementUnit: 'miles',
  feeLabel: 'Fee',
  viewDetailsLabel: 'View Details',
  milesLabel: 'miles',
  labelForFiveOrMoreNights: "You're getting a fifth night free for every four you book.",
  previousEEORateLabel: 'was',
  viewMapLabel: 'View Map',
  memberExclusiveLabel: 'Member Exclusive',
  viewHotelDetailsLabel: 'View Hotel Details',
  quickFilterListArray: [
    {
      amenitiesTagId: 'all-inclusive',
      amenitiesTagTitle: 'All-Inclusive',
    },
    {
      amenitiesTagId: 'breakfast',
      amenitiesTagTitle: 'Free Breakfast',
    },
    {
      amenitiesTagId: 'pool',
      amenitiesTagTitle: 'Pool',
    },
    {
      amenitiesTagId: 'pet-friendly',
      amenitiesTagTitle: 'Pet Friendly',
    },
  ],
  continueText: 'Continue',
  starsLabel: 'stars of',
  avgPerNightLabel: 'Avg/night',
  ofLabel: 'of',
  applyLabel: 'Apply',
  showFullPriceByDefault: false,
  currencyLabel: '',
  mapLabel: 'Map',
  allFilterLabel: 'All Filters',
  alertsListArray: [
    {
      alertMsgType: 'alertDefaultErrorNotification',
      alertMsgTypeName: 'alertDefaultErrorNotification',
      alertCodeListModel: [
        {
          alertMessageLabel:
            "We're temporarily unable to display the information you requested. Please try again later.",
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertTooManyPropertiesNotification',
      alertMsgTypeName: 'alertTooManyPropertiesNotification',
      alertCodeListModel: [
        {
          alertMessageLabel:
            'There are too many properties in your results to display pricing and availability information. Please further refine your search results.',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertCurrenyUpdateNotification',
      alertMsgTypeName: 'alertCurrenyUpdateNotification',
      alertCodeListModel: [
        {
          alertLinkTextLabel: 'Show me rates in local currency.',
          alertMessageLabel: 'When you reserve you will see the local currency of the property. ${AlertLinkTextLabel}',
          stringNeedsToBeSplit: false,
          alertHeadingLabel: 'Currency Updated',
        },
      ],
    },
    {
      alertMsgType: 'alertTooManyPropertiesNotification',
      alertMsgTypeName: 'clearAllFilters',
      alertCodeListModel: [
        {
          alertLinkTextLabel: 'clear all filters',
          alertMessageLabel:
            'To see available properties, please try changing your filters or ${AlertLinkTextLabel} to see all results for your destination.',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertErrorMsg',
      alertMsgTypeName: 'noNearAddressPropertyResult',
      alertCodeListModel: [
        {
          alertLinkTextLabel: 'hotel directory',
          alertMessageLabel:
            'Please verify that the Near an Address field contains a valid street address and country, and either a city, state, or zip code. If your entry is accurate, there may be no hotels within 50 miles of your desired address. Please consult our ${AlertLinkTextLabel} for alternate locations.',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertErrorMsg',
      alertMsgTypeName: 'noHotelsWithinRadius',
      alertCodeListModel: [
        {
          alertLinkTextLabel: 'property directory',
          alertMessageLabel:
            'Let’s try something else. If you’ve entered the right city, state, country, point of interest or airport code, we may not have a property within a 50-mile radius.  Check our ${AlertLinkTextLabel} for other locations. ',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertErrorMsg',
      alertMsgTypeName: 'noAvailabilityWithinRadius',
      alertCodeListModel: [
        {
          alertMessageLabel:
            'We searched a 50-mile radius and can’t find a match for your dates. Either change your dates or check our property directory for other locations',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertErrorMsg',
      alertMsgTypeName: 'serverStubborn',
      alertCodeListModel: [
        {
          alertMessageLabel: 'Our server is being stubborn, please try again',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertErrorMsg',
      alertMsgTypeName: 'noAvailabilityMaxcapacity',
      alertCodeListModel: [
        {
          alertMessageLabel:
            'There is no availability for the number of guests per room you requested. Try searching with using additional rooms and/or fewer guests per room.',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertTooManyPropertiesNotification',
      alertMsgTypeName: 'unsuccessfulSellWarning',
      alertCodeListModel: [
        {
          alertMessageLabel:
            'Your selected property has no available rooms. Please try searching again with a different property or dates.',
          stringNeedsToBeSplit: false,
        },
      ],
    },
    {
      alertMsgType: 'alertTooManyPropertiesNotification',
      alertMsgTypeName: 'alertRatesUnavailableWarning',
      alertCodeListModel: [
        {
          alertMessageLabel:
            'We’re having some trouble getting those room rates right now. Please select a property to check availability.',
          stringNeedsToBeSplit: false,
        },
      ],
    },
  ],
  rateUnavailableLabel: 'Rate Unavailable',
  openingSoonLabel: 'Opening Soon',
  pointsLabel: 'Points',
  editToSeeRatesLabel: 'To see rate, edit guests or rooms.',
  newTagLabel: 'NEW',
  hotelTypeLabel: 'Property Type',
  monthsShort: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
  squareFallBackImageURL: 'https://cache.marriott.com/is/image/marriotts7prod/ar-mspac-error-image-28944:Square',
  dailyDestinationFeeLabel: 'Daily Destination Fee',
  ratesUnavailableLabel: 'Rates Unavailable',
  newEEORateLabel: 'now',
  dataLayer: {
    'searchresults-235b0a1329': {
      '@type': 'mi-aem-shop-spa/components/content/searchresults/v1/searchresults',
      'repo:modifyDate': '2025-11-12T09:06:23Z',
    },
  },
  showAvailableHotelsOnlyLabel: 'Show available properties only',
  ratesPerNightLabel: '/ Night',
  soldOutLabel: 'Sold Out',
  disableHotelHeaderAndReviewLinks: false,
  showCountryFullPriceByDefault: 'UK,NL',
  filterTaxesLabel: 'Show rates with taxes and all fees',
  eliteExclusiveLabel: 'Elite Exclusive Offer',
  adultsOnlyMessageLabel: 'This property accepts adult guests only.',
  unitFromDestinationLabel: 'mi from destination',
  showAvailabilityLabel: 'View Other Dates',
  clearLabel: 'Clear',
  perNightLabel: '/ Night',
  descriptorSearchLabel: 'English',
  categorizedBrandsArray: [
    {
      brandsLabelListItems: [
        {
          brandTagId: 'EB',
          brandTagTitle: 'Edition',
        },
        {
          brandTagId: 'RZ',
          brandTagTitle: 'The Ritz-Carlton',
        },
        {
          brandTagId: 'LC',
          brandTagTitle: 'The Luxury Collection',
        },
        {
          brandTagId: 'XR',
          brandTagTitle: 'St Regis',
        },
        {
          brandTagId: 'WH',
          brandTagTitle: 'W Hotels',
        },
        {
          brandTagId: 'JW',
          brandTagTitle: 'JW Marriott',
        },
        {
          brandTagId: 'BG',
          brandTagTitle: 'BVLGARI',
        },
      ],
      selectAllbrandsTypeLabel: 'Select All',
      brandsTypeLabel: 'LUXURY',
      clearAllbrandsTypeLabel: 'Clear All',
    },
    {
      brandsLabelListItems: [
        {
          brandTagId: 'MC',
          brandTagTitle: 'Marriott Hotels Resorts & Suites',
        },
        {
          brandTagId: 'SI',
          brandTagTitle: 'Sheraton',
        },
        {
          brandTagId: 'MV',
          brandTagTitle: 'Marriott Vacation Club',
        },
        {
          brandTagId: 'DE',
          brandTagTitle: 'Delta Hotels',
        },
        {
          brandTagId: 'WI',
          brandTagTitle: 'Westin',
        },
        {
          brandTagId: 'MD',
          brandTagTitle: 'Le Meridien',
        },
        {
          brandTagId: 'BR',
          brandTagTitle: 'Renaissance Hotels',
        },
        {
          brandTagId: 'AK',
          brandTagTitle: 'Autograph Collection',
        },
        {
          brandTagId: 'TX',
          brandTagTitle: 'Tribute Portfolio',
        },
        {
          brandTagId: 'DS',
          brandTagTitle: 'Design Hotels',
        },
        {
          brandTagId: 'GE',
          brandTagTitle: 'Gaylord Hotels',
        },
        {
          brandTagId: 'MG',
          brandTagTitle: 'MGM Collection',
        },
        {
          brandTagId: 'OC',
          brandTagTitle: 'Outdoor Collection',
        },
      ],
      selectAllbrandsTypeLabel: 'Select All',
      brandsTypeLabel: 'PREMIUM',
      clearAllbrandsTypeLabel: 'Clear All',
    },
    {
      brandsLabelListItems: [
        {
          brandTagId: 'CY',
          brandTagTitle: 'Courtyard Hotels',
        },
        {
          brandTagId: 'FP',
          brandTagTitle: 'Four Points',
        },
        {
          brandTagId: 'SH',
          brandTagTitle: 'Springhill Suites',
        },
        {
          brandTagId: 'FI',
          brandTagTitle: 'Fairfield Inn',
        },
        {
          brandTagId: 'PR',
          brandTagTitle: 'Protea',
        },
        {
          brandTagId: 'AR',
          brandTagTitle: 'AC Hotels',
        },
        {
          brandTagId: 'AL',
          brandTagTitle: 'Aloft',
        },
        {
          brandTagId: 'OX',
          brandTagTitle: 'Moxy',
        },
        {
          brandTagId: 'XE',
          brandTagTitle: 'City Express by Marriott',
        },
        {
          brandTagId: 'XF',
          brandTagTitle: 'Four Points Flex by Sheraton',
        },
        {
          brandTagId: 'SE',
          brandTagTitle: 'Series',
        },
        {
          brandTagId: 'CM',
          brandTagTitle: 'CitizenM',
        },
      ],
      selectAllbrandsTypeLabel: 'Select All',
      brandsTypeLabel: 'SELECT',
      clearAllbrandsTypeLabel: 'Clear All',
    },
    {
      brandsLabelListItems: [
        {
          brandTagId: 'RI',
          brandTagTitle: 'Residence Inn',
        },
        {
          brandTagId: 'TS',
          brandTagTitle: 'TownePlace Suites',
        },
        {
          brandTagId: 'ER',
          brandTagTitle: 'Marriott Executive Apartments',
        },
        {
          brandTagId: 'EL',
          brandTagTitle: 'Element',
        },
        {
          brandTagId: 'BA',
          brandTagTitle: 'Apartments by Marriott Bonvoy',
        },
        {
          brandTagId: 'RS',
          brandTagTitle: 'StudioRes',
        },
      ],
      selectAllbrandsTypeLabel: 'Select All',
      brandsTypeLabel: 'LONGER STAY',
      clearAllbrandsTypeLabel: 'Clear All',
    },
  ],
  currencyListArray: [
    {
      currencyTag: 'USD',
    },
    {
      currencyTag: 'AUD',
    },
    {
      currencyTag: 'CAD',
    },
    {
      currencyTag: 'EUR',
    },
    {
      currencyTag: 'GBP',
    },
    {
      currencyTag: 'HKD',
    },
    {
      currencyTag: 'JPY',
    },
    {
      currencyTag: 'MXN',
    },
    {
      currencyTag: 'CNY',
    },
    {
      currencyTag: 'ZAR',
    },
    {
      currencyTag: 'IDR',
    },
    {
      currencyTag: 'RUB',
    },
    {
      currencyTag: 'KRW',
    },
    {
      currencyTag: 'ILS',
    },
  ],
  priceLabel: 'Price',
  mapViewNightLabel: 'Night',
  hotelsLabel: 'Properties',
  goToViewHotelDetailsLabel: 'Go To Details opens in New window',
  classicFallBackImageURL: 'https://cache.marriott.com/is/image/marriotts7prod/ar-mspac-error-image-28944:Classic-Hor',
  dailyLabel: 'daily',
  goToHotelDetailsLabel: 'Go to Hotel Details',
  anyPriceLabel: 'Any Price',
  pointsPerStayLabel: 'Points / Stay',
  recentlyViewedHeading: 'RECENTLY VIEWED',
  showAvailableHotelLabel: 'View Other Dates',
  fallBackImageAltText: 'Image Unavailable',
  fullyRenovatedLabel: 'FULLY RENOVATED',
  recentlyRenovatedLabel: 'RECENTLY RENOVATED',
  nextLabel: 'Next',
  componentErrorMessage:
    'We are currently unable to display the information you requested. Please try again in few moments',
  maximumGuestsExceededLabel: 'This property won’t allow that many guests in one room.',
  surchargeCostsSearchLabel: 'Surcharge for Ordinance Costs',
  filterLabel: 'Filters',
  adultsOnlyLabel: 'ADULTS ONLY',
  dailyResortFeeLabel: 'Daily Resort Fee',
  includesLabel: 'Includes',
  renovatedRoomsLabel: 'RENOVATED ROOMS',
  propertyCardDrawerLabel: 'property card drawer',
  editGuestsOrRoomsLabel: 'Edit guests or rooms.',
  editGuestsOrRoomsLabelRates: 'To see rate, edit guests or rooms.',
  removeChildGuests: 'Please remove child guest(s).',
  dailyTourismMarketingFeeLabel: 'Daily Tourism Marketing Fee',
  fromLabel: 'From',
  allInclusiveLabel: 'all-inclusive',
  selectPriceSubLabel: 'Select Price Per Night',
  showLessLabel: 'Show Less',
  imageUnavailableLabel: 'Image Unavailable',
  labelForFourNights: 'Get a free fifth night for every four you book.',
  taxesAndFeesIncluded: 'Taxes and all fees included',
  cashFlowTaxesAndFeesIncluded: 'Taxes & fees included',
  nightIncludesTaxesAndFees: 'includes taxes & fees',
  destinationAmenityLabel: 'Destination',
  addListLabel: 'List',
  showingLabel: 'Showing',
  showMoreLabel: 'Show more',
  newHotelLabel: 'NEW PROPERTY',
  surchargeTooltipHeadingLabel: 'Surcharge for Ordinance Costs',
  brandsLabel: 'Brands',
  unavailableLabel: 'Unavailable',
  removeChildrenMessageShort: 'Please remove child guest(s).',
  renovatedLobbyLabel: 'RENOVATED LOBBY',
  sortByOptionsADALabel: 'sort by options dropdown opens in a modal window',
  caseSenstiveHotelsLabel: 'hotels',
  unSelectAllLabel: 'Clear All',
};
